import { getFetch } from '../fetch';

import { apiConfig } from '../config';

export function getCourseJournal(courseId: any) {
    const { apiGetCourseJournal } = apiConfig.getStaticUrls();

    return getFetch(`${apiGetCourseJournal}${courseId}/`);
}
